/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

/** 
  All of the routes for the Material Dashboard 2 React are added here,
  You can add a new route, customize the routes and delete the routes here.

  Once you add a new route on this file it will be visible automatically on
  the Sidenav.

  For adding a new route you can follow the existing routes in the routes array.
  1. The `type` key with the `collapse` value is used for a route.
  2. The `type` key with the `title` value is used for a title inside the Sidenav. 
  3. The `type` key with the `divider` value is used for a divider between Sidenav items.
  4. The `name` key is used for the name of the route on the Sidenav.
  5. The `key` key is used for the key of the route (It will help you with the key prop inside a loop).
  6. The `icon` key is used for the icon of the route on the Sidenav, you have to add a node.
  7. The `collapse` key is used for making a collapsible item on the Sidenav that has other routes
  inside (nested routes), you need to pass the nested routes inside an array as a value for the `collapse` key.
  8. The `route` key is used to store the route location which is used for the react router.
  9. The `href` key is used to store the external links location.
  10. The `title` key is only for the item with the type of `title` and its used for the title text on the Sidenav.
  10. The `component` key is used to store the component of its route.
*/
import { Navigate } from "react-router-dom";

// Material Dashboard 2 React layouts
import Dashboard from "pages/riservata/Dashboard";

import Contratto from "pages/riservata/expo_partecipazioni/Contratto";
import ExpoRichiestaConfirm from "pages/riservata/expo_richieste/ExpoRichiestaConfirm";
import ExpoRichiesteEditStep1 from "pages/riservata/expo_richieste/ExpoRichiesteEditStep1";
import ExpoRichiesteEditStep2 from "pages/riservata/expo_richieste/ExpoRichiesteEditStep2";
import ElencoRichieste from "pages/riservata/expo_richieste/ExpoRichiesteList";
import ExpoRichiestaPDFVis from "pages/riservata/expo_richieste/ExpoRichiestePDFVis";
import ExpoRichiesteStart from "pages/riservata/expo_richieste/ExpoRichiesteStart";


import AuthService from 'services/API/Auth/AuthService.js';

// @mui icons
import Icon from "@mui/material/Icon";
import ElencoMyMessaggi from "pages/riservata/comunicazioni/ElencoMessaggiRead";
import MessaggioRead from "pages/riservata/comunicazioni/MessaggioRead";
import AreaFiera from "pages/riservata/expo_partecipazioni/AreaFiera";
import Pass from "pages/riservata/expo_partecipazioni/Pass";
import ContrattoVis from "pages/riservata/expo_partecipazioni/ContrattoVis";
import DocumentiFiera from "pages/riservata/expo_partecipazioni/DocumentiFiera";
import RegolamentoTecnicoAccept from "pages/riservata/expo_partecipazioni/RegolamentoTecnicoAccept";
import DuvriAccept from "pages/riservata/expo_partecipazioni/DuvriAccept";
import DatiCatalogoVis from "pages/riservata/expo_partecipazioni/DatiCatalogoVis";
import ServiziFiera from "pages/riservata/expo_partecipazioni/ServiziFiera";
import DotazioniVis from "pages/riservata/expo_partecipazioni/DotazioniVis";
import InvitiVis from "pages/riservata/expo_partecipazioni/InvitiVis";
import ExpoRichiesteAviStart from "pages/riservata/expo_richieste/ExpoRichiesteAviStart";





function PrivateRoute({ children }) {





  const isLoggedIn = AuthService.isLoggedIn();


  return isLoggedIn ? children : <Navigate to="/forbidden" />;
}

const id_mic = AuthService.getCurrentUser();
//console.log (id_mic);


function ExpoRoute({ children }) {
  const isLoggedIn = AuthService.isLoggedIn();
  if (isLoggedIn) {
    const isExpo = AuthService.isExpo();
    // console.log("isExpo="+isExpo);
    return isExpo ? children : <Navigate to="/forbidden" />;
  } else
    return <Navigate to="/forbidden" />;
}
const debug = false;
const routesPart = (stato_man, partecipa, dotazioni_validate, isAvi) => [
  {
    type: "collapse",
    name: "Dashboard",
    key: "dashboard",
    icon: <Icon fontSize="small">dashboard</Icon>,
    route: "/welcome",
      activeFor: ["/welcome"],
    component: <PrivateRoute><Dashboard /></PrivateRoute>,
  },
  {
    type: "title",
    title: "Messaggi",
    key: "msg_menu",
  },
  {
    type: "collapse",
    name: "Messaggi Ricevuti",
    key: "expo_messaggi_elenco",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/messaggi_expo",
    activeFor: ["/messaggi_expo","/messaggioRead"],
    component: <PrivateRoute><ElencoMyMessaggi /></PrivateRoute>,
  },
  {
    type: "not-visible",
    name: "Read Messaggio",
    key: "messaggioRead",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/messaggioRead",
    component: <ExpoRoute><MessaggioRead /></ExpoRoute>,
  },

  {
    type: (stato_man < 1 && !debug   && AuthService.getCurrentUser().id != 28 && AuthService.getCurrentUser().id != 40 && AuthService.getCurrentUser().id != 722) ? "not-visible" : "title",
    title: "Espositori",
    key: "espositori_menu",
  },
  {
    type: (stato_man < 1 && !debug  && AuthService.getCurrentUser().id != 28 && AuthService.getCurrentUser().id != 40 && AuthService.getCurrentUser().id != 722) ? "not-visible" : "collapse",
    name: "Proposte di Partecipazione",
    key: "expo_richiesteList",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/expo_richieste",
        activeFor: ["/expo_richieste","/expo_richiesteStart","/expo_richiesteAviStart","/expo_richiestaEdit1", "/expo_richiestaEdit2","/expo_richiestaConfirm"],
    component: <PrivateRoute><ElencoRichieste /></PrivateRoute>,
  },

  {
    type: "not-visible",
    name: "Start ",
    key: "expo_richiesteStart",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/expo_richiesteStart",
    component: <ExpoRoute><ExpoRichiesteStart /></ExpoRoute>,
  },
  {
    type: "not-visible",
    name: "Start Avi ",
    key: "expo_richiesteAviStart",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/expo_richiesteAviStart",
    component: <ExpoRoute><ExpoRichiesteAviStart /></ExpoRoute>,
  },

  {
    type: "not-visible",
    name: "Nuova Proposta",
    key: "expo_richiestaEdit1",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/expo_richiestaEdit1",
    component: <ExpoRoute><ExpoRichiesteEditStep1 /></ExpoRoute>,
  },

  {
    type: "not-visible",
    name: "Nuova Proposta 2",
    key: "expo_richiestaEdit2",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/expo_richiestaEdit2",
    component: <ExpoRoute><ExpoRichiesteEditStep2 /></ExpoRoute>,
  },

  {
    type: "not-visible",
    name: "Confirm ",
    key: "expo_richiestaConfirm",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/expo_richiestaConfirm",
    component: <ExpoRoute><ExpoRichiestaConfirm /></ExpoRoute>,
  },
  {
    type: "not-visible",
    name: "Confirm ",
    key: "expo_richiestaPDF",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/expo_richiestaPDFVis",
    component: <PrivateRoute><ExpoRichiestaPDFVis /></PrivateRoute>,
  },

  {
    type: ((!partecipa || stato_man < 2) && !debug  && AuthService.getCurrentUser().id != 28 && AuthService.getCurrentUser().id != 40 && AuthService.getCurrentUser().id != 722) ? "not-visible" : "title",
    title: "Area Fiera",
    key: "af_menu",
  },


  //CONTRATTO

  {
    type: "not-visible",
    name: "Contratto edit",
    key: "contratto_edit",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/contratto",
    component: <PrivateRoute><Contratto /></PrivateRoute>,
  },
  {
    type: ((!partecipa || stato_man < 2) && !debug  && AuthService.getCurrentUser().id != 28 && AuthService.getCurrentUser().id != 40 && AuthService.getCurrentUser().id != 722) ? "not-visible" : "collapse",
    name: "Contratto e altri documenti",
    key: "contratto",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/contratto_vis",
    component: <PrivateRoute><ContrattoVis /></PrivateRoute>,
  },
  //MODULI OBBLIGATORI

  {
    type: ((!partecipa || isAvi || stato_man < 2) && !debug  && AuthService.getCurrentUser().id != 28 && AuthService.getCurrentUser().id != 40 && AuthService.getCurrentUser().id != 722) ? "not-visible" : "collapse",
    name: "Moduli Obbligatori",
    key: "doc_fiera",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/documenti_fiera",
    component: <PrivateRoute><DocumentiFiera /></PrivateRoute>,
  },

  {
    type: "not-visible",
    name: "RT accept",
    key: "rt_accept",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/regolamento_tecnico",
    component: <PrivateRoute><RegolamentoTecnicoAccept /></PrivateRoute>,
  },

  //SERVIZI FACOLTATIVI

  {
    type: ((!partecipa || isAvi || stato_man < 2) && !debug  && AuthService.getCurrentUser().id != 28 && AuthService.getCurrentUser().id != 40 && AuthService.getCurrentUser().id != 722) ? "not-visible" : "collapse",
    name: "Servizi Facoltativi",
    key: "servizi_fiera",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/servizi_fiera",
    component: <PrivateRoute><ServiziFiera /></PrivateRoute>,
  },


  //ASSEGNAZIONE AREA
  {
    type: ((!partecipa || stato_man < 3) && !debug  && AuthService.getCurrentUser().id != 28 && AuthService.getCurrentUser().id != 40 && AuthService.getCurrentUser().id != 722) ? "not-visible" : "collapse",
    name: "Assegnazione Area",
    key: "area_fiera",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/area_fiera",
    component: <PrivateRoute><AreaFiera /></PrivateRoute>,
  },

  //CATALOGO

  {
    type: ((!partecipa || stato_man < 2) && !debug  && AuthService.getCurrentUser().id != 28 && AuthService.getCurrentUser().id != 40 && AuthService.getCurrentUser().id != 722) ? "not-visible" : "collapse",
    name: "Dati per il Catalogo",
    key: "catalogo_vis",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/dati_catalogo",
    component: <PrivateRoute><DatiCatalogoVis /></PrivateRoute>,
  },
  {
    type: ((!partecipa || stato_man < 2) && !debug  && AuthService.getCurrentUser().id != 28 && AuthService.getCurrentUser().id != 40 && AuthService.getCurrentUser().id != 722) ? "not-visible" : "collapse",
    name: "Pass Allestimento/Disallestimento",
    key: "duvri_accept",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/duvri",
    component: <PrivateRoute><DuvriAccept /></PrivateRoute>,
  },
  {
    type: "not-visible",
    name: "Pass Allestimento/Disallestimento",
    key: "pass",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/pass",
    component: <PrivateRoute><Pass /></PrivateRoute>,
  },
  {
    type: ((!partecipa || stato_man < 2 || !dotazioni_validate) && !debug && AuthService.getCurrentUser().id != 28 && AuthService.getCurrentUser().id != 40 && AuthService.getCurrentUser().id != 722) ? "not-visible" : "title",
    title: "DOTAZIONI",
    key: "dot_menu",
  },
  //DOTAZIONI
  {
    type: ((!partecipa || stato_man < 2 || !dotazioni_validate) && !debug && AuthService.getCurrentUser().id != 28 && AuthService.getCurrentUser().id != 40 && AuthService.getCurrentUser().id != 722) ? "not-visible" : "collapse",
    name: "Dotazioni",
    key: "dotazioni_vis",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/dotazioni",
    component: <PrivateRoute><DotazioniVis /></PrivateRoute>,
  },
  {
    type: ((!partecipa || stato_man < 4 || !dotazioni_validate) && !debug && AuthService.getCurrentUser().id != 28 && AuthService.getCurrentUser().id != 40 && AuthService.getCurrentUser().id != 722) ? "not-visible" : "collapse",
    name: "Biglietti Ridotti",
    key: "inviti_ridotti_vis",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/inviti_ridotti",
    component: <PrivateRoute><InvitiVis tipo="IR" /></PrivateRoute>,
  },
  {
    type: ((!partecipa || stato_man < 4 || !dotazioni_validate) && !debug && AuthService.getCurrentUser().id != 28 && AuthService.getCurrentUser().id != 40 && AuthService.getCurrentUser().id != 722) ? "not-visible" : "collapse",
    name: "Biglietti Omaggio",
    key: "inviti_omaggio_vis",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/inviti_omaggio",
    component: <PrivateRoute><InvitiVis tipo="IO" /></PrivateRoute>,
  },

  {
    type: ((!partecipa || stato_man < 4 || !dotazioni_validate) && !debug && AuthService.getCurrentUser().id != 28 && AuthService.getCurrentUser().id != 40 && AuthService.getCurrentUser().id != 722) ? "not-visible" : "collapse",
    name: "Pass Espositore",
    key: "pass_espositore_vis",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/pass_espositore",
    component: <PrivateRoute><InvitiVis tipo="PE" /></PrivateRoute>,
  },


];


export default routesPart;
